import axios from 'axios'
import React,{useEffect,useState} from 'react'

const Section1 = ({list}) => {

    //console.log(list)
    const parentUrl =window.location.host.indexOf("identity-v") > -1?"https://www.resound.global":""

    const [selectedCard, setSelectedCard]=useState(null)
    const [nickname, setNickname] =useState("")
    const [greetings, setGreetings] =useState("")
    const [error, setError] =useState("")
    const [loading, setLoading] =useState(false)
    const [result, setResult]=useState(null)
    const [showPopUp, setShowPopUp] =useState(false)
    const [showMeTheCard, setShowMeTheCard] =useState(null)
    
    const cards = ["1","2","3"]
    //const [list, setList] = useState([]);
    useEffect(() => {
        
        const script = document.createElement('script');
    
        script.src = '/events/js/main.js';
        script.async = true;
        document.body.appendChild(script);
        
        
    
        return () => {
          document.body.removeChild(script);
        };
      }, [parentUrl]);

      const onTextChange =(text) =>{
          setError("")
          if (text && text.length >130) {
              setError("內容請勿超過130字")
          } else {
              setGreetings(text)
          }
      }
      const onCardClick =(card) => {
        setSelectedCard(card)
        setShowPopUp(true)
        setResult(null)
      }

      const onShowCaseCardClick =(card) => {
        setShowMeTheCard(card)
        setShowPopUp(true)
        setResult(null)
      }

      const onSubmit =async()=>{
        setError("")
        if (nickname==="" || greetings==="" || !selectedCard) {
            
            setError("請完整填寫內容")

        } else if (nickname.length >15 ) {
            setError("暱稱請勿超過15字")
        }
        else if (greetings.length>130) {
            setError("賀詞內容請勿超過130字")
        }  
        

        
         else {
            const data = {nickname,greetings,selectedCard}
            console.log(data)
            const config = {
                headers: { 'Content-Type': 'application/json' }
              };
              setLoading(true)

              try {
                const res = await axios.post(parentUrl+"/api/idvecard/submit", data, config)
            
                setResult(res.data)
                setError("")
                setSelectedCard(null)
                setGreetings("")
                setNickname("")
                setLoading(false)
              } catch (error) {
                console.log(error.response.data)
                setResult(null)
                setError("錯誤:" + error.response.data.message )
                setLoading(false)
              }
            
            
            
        }

      }

      
    return (
        <>
            <section id="event_01" className="event_01">
            <div className="inner_wrap wow fadeInUp">
                <h2>紙短情深 週年慶祝福徵集</h2>
                <span>活動時間 即日起-7/8 23:59</span>
                <a name="btn-how" href="#btn-how" className="btn_link btn_how">參加辦法</a>
                <a name="btn-notice"  href="#btn-notice"  className="btn_link btn_notice">注意事項</a>
                <img src="/events/img/line.png" alt="" className="line"/>
                <div className="event_tip">
                    <p>
                        還記得第一次踏入莊園，首次參與追逐的感受嗎？ 還記得第一次大獲全勝/逃出生天時的興奮感嗎？<br />
                        還記得第一次抽中心儀時裝時的雀躍感受嗎？ 時光飛躍，那些微小瞬間都成為了珍貴的回憶……
                        <br /><br />
                        <b className="color_orange">
                            在這三年間，與 《第五人格》 相伴度過的時光，偵探們是否有想說的話，或是對 《第五人格》 的期許和祝福呢？
                        </b>
                        <br />
                        <br />
                        挑選一張喜歡的賀卡樣式，寫下對《第五人格》的三週年祝福吧！<br />
                        將完成的週年賀卡分享到 Facebook / Instagram 社群平台還可抽 《第五人格》 周邊喔！
                    </p>
                </div>
                <img src="/events/img/line.png" alt="" className="line" />

                {/* <!--選擇賀卡樣式--> */}
                <div className="select_card">
                    <h3>♦ 選擇賀卡樣式 寫下週年祝福 ♦</h3>
                    <div className="cards">
                        {cards.map(card=> <img src={`/events/img/card_0${card}.png`} 
                        alt="" 
                        key={`img-card-${card}`}
                        onClick={()=>onCardClick(card)}
                         /> )}
                        
                    </div>
                </div>

                {/* <!--賀卡輪播區--> */}
                <div className="e_card">
                    <h3>精選賀卡 將隨機顯示偵探們寫下的祝福</h3>
                    <div className="card_wrap">
                        {list.map(card => <div key={card._id} style={{width:"254px", height:"160px"}} className="download_01" onClick={()=>onShowCaseCardClick(card.imgUrl)}><img src={card.imgUrl} alt="" /></div>)}
                        
                       
                    </div>
                </div>
                <div className="see_more">
                    <span>點選下方按鈕觀看更多祝福</span>
                    <a href="https://www.facebook.com/hashtag/第五人格三週年快樂/" className="btn_link" target="_blank" rel="noreferrer">Facebook</a>
                    <a href="https://www.instagram.com/explore/tags/第五人格三週年快樂/" className="btn_link" target="_blank" rel="noreferrer">Instagram</a>
                </div> 

            </div>
        </section>
        <div className="popup2" style={showPopUp===true?{display:"block"}:{display:"none"}}>
            <div className="popup_wrap">
                <img className="popup_close" src="/events/img/btn_close.png" alt="關閉彈跳視窗" onClick={()=>{setShowPopUp(false);setSelectedCard(null);setShowMeTheCard(null)}}/>
                <div className="card_send" style={selectedCard?{display:"block"}:{display:"none"}}>
                    <textarea cols="50" rows="5" onChange={e=>onTextChange(e.target.value)} value={greetings}></textarea>
                    <input type="text" name="yourname" value={nickname} onChange={e=>setNickname(e.target.value)}/>
                    <img className="card_bg" src={selectedCard?`/events/img/card_send_0${selectedCard}.png`:""} alt=""/>
                    <span className={error?"alert":""}> {error?`※${error}`:"※請確認內容無誤後再送出，送出後就不得修改囉！"} </span>
                    {!loading? <button className="btn_link"  onClick={onSubmit}>送出</button>:<><div className="lds-ring"><div></div><div></div><div></div><div></div></div> </>}
                    
                    
                </div>
               
                <div className="card_download"  style={result?{display:"block"}:{display:"none"}}>
                    <img className="card_d_bg" src={result?.imgUrl} alt="" />
                    <span>別忘了下載保留週年賀卡圖片參加社群抽獎活動！<br />
                        (請點擊右鍵>另存圖片;或是手機長按後下載圖片。若跳出視窗將無法再次下載)</span>
            

                </div>
                <div className="card_display"  style={showMeTheCard?{display:"block"}:{display:"none"}}>
                    <img className="card_d_bg" src={showMeTheCard? showMeTheCard:""} alt="" />
                
                </div>
            </div>
        </div>
        </>
    )
}

export default Section1
